const DEFAULT_FONT_SIZE = 16;

export const px2rems = (px: number): string => `${px / DEFAULT_FONT_SIZE}rem`;
